iScreenWizard.controller('RenewPasswordController', function ($scope, $state, $mdDialog, Ajax, Dictionary, Profiel, userService) {
    $scope.nieuwwachtwoord1 = '';
    $scope.nieuwwachtwoord2 = '';

    $scope.renewPassword = function () {
        var params = {};
        params.nieuwwachtwoord1 = $scope.nieuwwachtwoord1;
        params.nieuwwachtwoord2 = $scope.nieuwwachtwoord2;

        Ajax.put('renewPassword', params).then(function (response) {
            if (response.data.succes) {
                // Password isn't expired anymore.
                userService.model.passwordExpired = 0;
                // Clear scope vars.
                $scope.nieuwwachtwoord1 = '';
                $scope.nieuwwachtwoord2 = '';
                // Reload user in userService.
                userService.SaveState();
                // Redirect to home.
                $state.go('home');
            } else {
                //something went wrong
                var errorMessage = Dictionary.translate('app.something_went_wrong', true);
                if (!response.data._errors.empty) {
                    errorMessage = "";
                    angular.forEach(response.data._errors, function (value, key) {
                        errorMessage += value + '<br/>';
                    });
                }
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title(Dictionary.translate('app.could_not_save', true))
                        .htmlContent(errorMessage)
                        .ariaLabel(Dictionary.translate('app.could_not_save', true))
                        .ok(Dictionary.translate('app.okay', true))
                );
            }
            // Clear scope vars.
            $scope.nieuwwachtwoord1 = '';
            $scope.nieuwwachtwoord2 = '';
        }, function () {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(Dictionary.translate('app.warning', true))
                    .textContent(Dictionary.translate('app.something_went_wrong', true))
                    .ariaLabel(Dictionary.translate('app.warning', true))
                    .ok(Dictionary.translate('app.okay', true))
            );

        });
    };
});